import _ from 'lodash';
import { GOAL_LEAD_GENERATION, GOAL_REACH_AND_CLICK, GOAL_LOCAL_OFFERS } from '@/services/GoalTypeService';

let genericConfig = {};

function isFieldVisible(fieldName) {
  if (!_.has(genericConfig, 'field_configuration.hidden')) {
    return true;
  }

  return genericConfig.field_configuration.hidden.findIndex(f => `${f}` === fieldName) === -1;
}

function removeHiddenFields(fullConfig) {
  const itemsToRemove = [];
  Object.values(fullConfig)
    .forEach((group, key) => {
      group.forEach(field => {
        if (!isFieldVisible(field)) {
          itemsToRemove.push({
            key: Object.keys(fullConfig)[key],
            name: field,
          });
        }
      });
    });

  itemsToRemove.forEach(item => {
    const index = fullConfig[item.key].findIndex(i => `${i}` === item.name);

    if (index !== -1) {
      fullConfig[item.key].splice(index, 1);
    }
  });

  return fullConfig;
}
function config(campaign, modeCount) {
  let fullConfig = {
    a: [
      'campaign.goal', 'target.locations', 'target.radius', 'target.age',
      'target.gender', 'target.interest', 'target.placement', 'budget', 'mode',
      'duration', 'reach.potential', 'reach.guaranteed', 'format',
    ],
    b: [
      'customer.company', 'customer.id', 'customer.email', 'customer.phone',
      'customer.facebook_email', 'landing_page', 'facebook_page', 'campaign.details.form_question',
    ],
    c: [
      'name', 'brief', 'images', 'start_date',
    ],
  };

  if (campaign) {
    if (campaign.goal_type === GOAL_LEAD_GENERATION) {
      fullConfig.a.splice(10, 0, 'estimated_leads');
      fullConfig.b.splice(5, 0, 'lead-email');
      fullConfig.b.splice(6, 0, 'lead-phone');
      fullConfig.b.splice(7, 0, 'privacy-policy-link');
    } else if (campaign.goal_type === GOAL_REACH_AND_CLICK) {
      fullConfig.a.splice(10, 0, 'estimated_clicks');
    }

    if (campaign.goal_type !== GOAL_LOCAL_OFFERS) {
      fullConfig.c.splice(2, 0, 'objective');
    }

    if (_.has(genericConfig, 'field_configuration.hidden')
        && genericConfig.field_configuration.hidden.indexOf('details.alliedCoupon') === -1) {
      fullConfig.c.splice(5, 0, 'coupon_code');
    }

    if (_.has(campaign, 'details.creativeRefreshCount')) {
      fullConfig.a.splice(11, 0, 'creative_refresh_count');
    }

    fullConfig = removeHiddenFields(fullConfig);

    if (modeCount === 1) {
      const index = fullConfig.a.findIndex(i => `${i}` === 'mode');
      fullConfig.a.splice(index, 1);
    }
  }
  return {
    proposal: {
      // fields to show in info box
      // array of arrays of strings (infobox having blocks having fields)
      // 1st array is always expanded, rest are collapsed on small screens
      infobox: [fullConfig.a.filter(i => i !== 'budget'), fullConfig.b, fullConfig.c],
    },
    checkout: {
      infobox: [fullConfig.a, fullConfig.b, fullConfig.c],
    },
    offer: {
      // see proposal.infobox
      infobox: [['target.gender', 'target.age', 'target.locations_with_radius', 'target.interest', 'target.language', 'target.placement']],
    },
  };
}

export function setConfig(cfg) {
  genericConfig = cfg;
}

export default config;



// WEBPACK FOOTER //
// ./src/configuration/infobox.js